import { createSelector } from 'reselect';

import { fetch } from 'lib/api';
import createReducer from 'lib/createReducer';
import constants from './constants';


const GET_TEAMS = 'teams/team/GET_TEAMS';
const GET_TEAMS_FULFILLED = 'teams/team/GET_TEAMS_FULFILLED';
// const GET_EMPLOYEE_COMPANY_SETTING = 'employees/employee/GET_EMPLOYEE_COMPANY_SETTING';
// const GET_EMPLOYEE_COMPANY_SETTING_FULFILLED = 'employees/employee/GET_EMPLOYEE_COMPANY_SETTING_FULFILLED';
// const GET_EMPLOYEE = 'employees/employee/GET_EMPLOYEE';
// const GET_EMPLOYEE_FULFILLED = 'employees/employee/GET_EMPLOYEE_FULFILLED';
// const POST_EMPLOYEE_ACTIVATE = 'employees/employee/POST_EMPLOYEE_ACTIVATE';
// const POST_EMPLOYEE_ACTIVATE_FULFILLED = 'employees/employee/POST_EMPLOYEE_ACTIVATE_FULFILLED';

export function getTeams(params) {
  return {
    type: GET_TEAMS,
    payload: fetch(constants.URLS.TEAM, { params }),
  };
}

// export function getEmployee(params) {
//   return {
//     type: GET_EMPLOYEE,
//     payload: fetch(`${constants.URLS.EMPLOYEE}${params.id}/`),
//   };
// }

// export function getEmployeeCompanySetting(params) {
//   return {
//     type: GET_EMPLOYEE_COMPANY_SETTING,
//     payload: fetch(constants.URLS.COMPANY, { params }),
//   };
// }

// export function postActivate(data) {
//   return {
//     type: POST_EMPLOYEE_ACTIVATE,
//     payload: post(constants.URLS.ACTIVATE, data),
//   };
// }

const defaultState = {
  list: { results: [] },
  detail: {},
  companyDetail: {}
};

function GET_TEAMS_FULFILLED_REDUCER(state, action) {
  return Object.assign({}, state, {
    list: action.payload ,
  });
}

// function GET_EMPLOYEE_FULFILLED_REDUCER(state, action) {
//   return Object.assign({}, state, {
//     detail: action.payload,
//   });
// }
// function GET_EMPLOYEE_COMPANY_SETTING_FULFILLED_REDUCER(state, action) {
//   return Object.assign({}, state, {
//     companyDetail: action.payload,
//   });
// }
// function POST_EMPLOYEE_ACTIVATE_FULFILLED_REDUCER(state, action) {
//   const singleton = new Singleton();
//   singleton.employeeAuth = action.payload.auth_token;
//   cookies.set('employeeToken', action.payload.auth_token, { path: '/' });
//   return merge(state, {
//     employeeToken: action.payload.auth_token,
//   });
// }
const handlers = {
  [GET_TEAMS_FULFILLED]: GET_TEAMS_FULFILLED_REDUCER,
};


const teamSelector = state => state.teams.team;

export const teamList = createSelector(
  teamSelector,
  instance => instance.list,
);

export const teamDetail = createSelector(
  teamSelector,
  instance => instance.detail,
);

// export const companyDetail = createSelector(
//   teamSelector,
//   instance => instance.companyDetail,
// );


export default createReducer(defaultState, handlers);
